import { render, staticRenderFns } from "./preview-input-number.vue?vue&type=template&id=0d8571a8&"
import script from "./preview-input-number.vue?vue&type=script&lang=js&"
export * from "./preview-input-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports